<template>
  <div>
    <MainHeader v-if="!isHomePage" />
    <router-view />
    <MainFooter />
  </div>
</template>

<script>
import MainHeader from '@/components/MainHeader'
import MainFooter from '@/components/MainFooter'
import {useRouter} from 'vue-router/dist/vue-router'
import {useRoute} from 'vue-router'
import {computed, onBeforeUnmount, onMounted} from 'vue'
export default {
  name: 'App',
  components: {MainFooter, MainHeader},

  setup() {
    const router = useRouter()
    const route = useRoute()

    const isHomePage = computed(() => {
      return route.name === 'home' || route.name === 'news'
    })

    function messageCB(message) {
      if (message.data.type === 'order-manage') {
        router.push({ name: 'order-edit', params: { id: message.data.other.id }, query: { phoneNumber: message.data.other.phone } })
      } else if (message.data.type === 'order-create') {
        router.push({ name: 'order-create', query: message.data.other?.query })
      }
    }

    onMounted(() => {
      window.addEventListener('message', messageCB)
    })

    onBeforeUnmount(() => {
      window.removeEventListener('message', messageCB)
    })

    return {
      isHomePage
    }
  }
}
</script>

<style>
</style>
